const BrandingStore = {
  logo_size: 45,
  series_colors: [],
};

export default BrandingStore;
